import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { TranslateModule } from '@ngx-translate/core';
import { IAdmissionReasonSummary } from '../../../../../interfaces/AdmissionPatient/IAdmissionReasonSummary';
import { Subject, takeUntil } from 'rxjs';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-admission-reason-summary',
  standalone: true,
  imports: [CommonModule, NzModalModule, NzIconModule, TranslateModule],
  templateUrl: './admission-reason-summary.component.html',
  styleUrls: ['./admission-reason-summary.component.css'],
})
export class AdmissionReasonSummaryComponent {
  public summary?: IAdmissionReasonSummary;

  @ViewChild('modalRef', { static: true }) modalRef!: NzModalRef;

  isVisible = false;
  private destroy$ = new Subject<void>();

  constructor(private readonly patientService: PatientService) {}

  ngOnInit(): void {
    this.patientService.showPatientAdmissionReasonSummarySub
      .pipe(takeUntil(this.destroy$))
      .subscribe((show) => (this.isVisible = !!show));

    this.patientService.patientAdmissionReasonSummarySub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IAdmissionReasonSummary | undefined) => {
        this.summary = data;
      });
  }

  handleCancel(): void {
    this.patientService.showPatientAdmissionReasonSummarySub.next(false);
    this.modalRef?.destroy();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.modalRef?.destroy();
  }
}
